import React, { useState } from 'react';

import "./AsesoresTable.scss"

const AsesoresTable = ({ data, onAsesorClick, small=false }) => {
  const [selectedAsesor, setSelectedAsesor] = useState(null);

  const handleRowClick = (asesor) => {
    setSelectedAsesor(asesor);
    onAsesorClick(asesor);
  };

  return (
    <div className={`asesores-table-container ${small ? "small" : ""}`}>
      <table className="asesores-table">
        <thead>
          <tr>
            <th>CUA</th>
            <th>Nombre</th>
            <th>Correo</th>
            <th>Celular</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          {data.map((asesor) => (
            <tr key={asesor.uuid} onClick={() => handleRowClick(asesor)}>
              <td>{asesor?.cua ?? " "}</td>
              <td>{asesor.nombre}</td>
              <td>{asesor.correo}</td>
              <td>{asesor.telefono}</td>
              <td>{asesor?.address_estado ?? " "}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AsesoresTable;